import { Card, Stack } from "@mui/material";
import React from "react";
import SvgDiagram from "../../SvgDiagram";

export default function TanitaMC780BasicHealthTableCard({data}) {
    const image = {
        w: 952, h: 550,
        src: "/assets/tanita/mc780/Body_Composition_Analysis_Result_1.png"
    }

    // age = age || 0;
    
    // // age = Math.c
    // fat = fat || 0;

    // let ageRatio = ratio(age, 20, 90);
    // let fatRatio = ratio(fat, 0, 3.0); // clamp(fat, 0, 3.0) / 50.0;

    // // let 
    // let x = lerp(115, 596, ageRatio); // age 
    // let y = lerp(70, 415, fatRatio); // fat
    const fatWeight = 80.0;
    const bone = 28.4;

    const col1 = [
        parseFloat(data.weight), 
        parseFloat(data.fat_p),
        parseFloat(data.fat_mass),
        parseFloat(data.ffm),
        parseFloat(data.muscle_mass),
        parseFloat(data.bone_mass),
        parseFloat(data.bmi),
        parseFloat(data.smm),
        parseFloat(data.metabolic_age),        
    ]
    const col2 = [
        data.weight_range,
        data.fat_p_range,
        data.fat_mass_range,
        data.ffm_range,
        data.muscle_mass_range,
        data.bone_mass_range,
        data.bmi_range,
    ]

    

    let yOffset; 
    yOffset = 54;
    const col1Markers = col1.map((value, index) => {
        return { type: "text", x: 330, y: 58 + yOffset*index, 
            fontSize:2, text: value.toFixed(1), color: "black"  
        }
    });

    const col2Markers = col2.map((value, index) => {
        return { type: "text", x: 490, y: 58 + yOffset*index, 
            fontSize:2, text: value, color: "black"  
        }
    });


    
    const markers = [
        ...col1Markers,
        ...col2Markers,
        // ...upperMarkers,
        // ...lowerMarkers,
        // { type: "text", x: 260, y: 50, fontSize:2, text: fatWeightStr, color: "black", origin: "" },
        // { type: "text", x: 260 + offset, y: 50, fontSize:2, text: boneStr, color: "black", origin: "" },
        
    //    { type: "dot", x: x, y: y, r: 10, color: "red", origin: "bottom-left" }
    ];
    // weight	fat_p	fat_mass	ffm	muscle_mass
    // bmi 
// metabolic_age
// target_fat_p	predicted_weight	predicted_fat_mass
    
    
    // const imageW = 711;
    // const imageH = 531;
    return <Card sx={{maxWidth:900}}>
        <Stack direction="column">
            <SvgDiagram image={image} markers={markers}/>
        </Stack>
    </Card>
}